import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DockingState } from './docking.reducers';

export const dockingState = createFeatureSelector<DockingState>('docking');

// Docking Context
export const dockingContextSelector = createSelector(dockingState, dockingState => dockingState.dockingContext);
export const userMonitoringSelector = createSelector(dockingState, dockingState => dockingState.userMonitoring);
